import React from 'react'
import CrossPlatformImage from '../../components/CrossPlatformImage'

import logo from '../../../assets/img/logo/logo.png'
import logo2x from '../../../assets/img/logo/logo_2x.png'
import logo3x from '../../../assets/img/logo/logo_3x.png'

const HansGretelLogo = () => {
  return (
    <CrossPlatformImage
      source={logo}
      source2x={logo2x}
      source3x={logo3x}
      alt="Hans & Gretel Logo"
    />
  )
}

export default HansGretelLogo
